import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./sudanLanding.scss";
import SudanFlag from "../assets/Flag-Sudan.svg";
import KaporgBlueIcon from "../assets/KAPorg-blue.svg";
import { useLanguage } from "../i18n/LanguageContext";

const NAV_LINKS = [
   { label: "How it works", to: "/how-it-works" },
   { label: "Capacity Accelerator Program", to: "/capacity-accelerator-program" },
   { label: "Humanitarian Reset", to: "/humanitarian-reset" },
   { label: "Who it's for", to: "/who-its-for" }
];

const LANGUAGES = [
   { code: "en", label: "English", short: "EN" },
   { code: "ar", label: "العربية", short: "ع" }
];

const LanguageSwitcher = () => {
   const { lang, setLang } = useLanguage();
   const [open, setOpen] = useState(false);
   const ref = useRef(null);

   useEffect(() => {
      const onClickOutside = (e) => {
         if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", onClickOutside);
      return () => document.removeEventListener("mousedown", onClickOutside);
   }, []);

   const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

   return (
      <div className="sd-lang" ref={ref}>
         <button
            type="button"
            className="sd-lang-toggle"
            aria-haspopup="listbox"
            aria-expanded={open}
            onClick={() => setOpen((o) => !o)}
         >
            <span className="sd-lang-globe" aria-hidden="true">
               🌐
            </span>
            <span className="sd-lang-current">{current.short}</span>
            <span className="sd-lang-caret" aria-hidden="true">
               ▾
            </span>
         </button>
         {open && (
            <ul className="sd-lang-menu" role="listbox">
               {LANGUAGES.map((l) => (
                  <li key={l.code} role="option" aria-selected={l.code === lang}>
                     <button
                        type="button"
                        className={`sd-lang-item ${l.code === lang ? "active" : ""}`}
                        onClick={() => {
                           setLang(l.code);
                           setOpen(false);
                        }}
                     >
                        {l.label}
                     </button>
                  </li>
               ))}
            </ul>
         )}
      </div>
   );
};

const Navbar = () => {
   const [menuOpen, setMenuOpen] = useState(false);
   const closeMenu = () => setMenuOpen(false);
   const { t, enabled } = useLanguage();

   return (
      <nav className="sd-nav">
         <div className="container">
            <div className="sd-nav-inner">
               <Link to="/auth/login" className="sd-nav-brand" onClick={closeMenu}>
                  <img src={SudanFlag} alt="Sudan flag" className="sd-flag" />
                  <span>{t("Sudan")}</span>
                  <span className="sd-divider" />
                  <img src={KaporgBlueIcon} alt="KAPorg" className="sd-logo" />
               </Link>

               <button
                  type="button"
                  className="sd-nav-toggle"
                  aria-label="Toggle navigation"
                  onClick={() => setMenuOpen((o) => !o)}
               >
                  {menuOpen ? "✕" : "☰"}
               </button>

               <div className={`sd-nav-links ${menuOpen ? "open" : ""}`}>
                  {NAV_LINKS.map((link) => (
                     <Link key={link.to} to={link.to} onClick={closeMenu}>
                        {t(link.label)}
                     </Link>
                  ))}
                  <Link to="/auth/login" className="sd-nav-login" onClick={closeMenu}>
                     {t("Log in")}
                  </Link>
                  <Link
                     to="/auth/registration"
                     className="sd-btn sd-btn-primary"
                     onClick={closeMenu}
                  >
                     {t("Register free")}
                  </Link>
                  {enabled && <LanguageSwitcher />}
               </div>
            </div>
         </div>
      </nav>
   );
};

export default Navbar;
